import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Curtain Icon Style 03 - Curtains Closed (Material Symbol)
 * Shows closed curtains icon, changes fill based on state
 * - isOn = true (open): 青綠色
 * - isOn = false (closed): 灰色
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:curtains_closed
 */
export const Style03_CurtainsClosed: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-teal-500' : 'text-slate-400';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      curtains_closed
    </span>
  );
};

export default Style03_CurtainsClosed;
